export default __webpack_public_path__ + "static/media/event-info-balloon-2.29e29f0e.jpg";